import {
  GET_ALL_PERMISSIONS_REQUEST,
  GET_ALL_PERMISSIONS_SUCCESS,
  GET_ALL_PERMISSIONS_FAILURE,
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_FAILURE,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_FAILURE,
  GET_USERS_AND_ROLES_START,
  GET_USERS_AND_ROLES_SUCCESS,
  GET_USERS_AND_ROLES_FAIL,
  UPDATE_USER_ROLES_REQUEST,
  UPDATE_USER_ROLES_SUCCESS,
  UPDATE_USER_ROLES_FAILURE,
} from './types';

const initialState = {
  roles: {},
  permissions: [],
  loadingPermissions: false,
  loading: false,
  error: null,
  errorPermissions: null,
  usersAndRolesData: {},
  loadingUsersAndRoles: false,
  errorUsersAndRoles: null,
};

const roleAndPermissionReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case GET_ALL_PERMISSIONS_REQUEST:
      return { ...state, loadingPermissions: true, errorPermissions: null };
    case GET_ALL_PERMISSIONS_SUCCESS:
      return {
        ...state,
        permissions: action.payload,
        loadingPermissions: false,
      };
    case GET_ALL_PERMISSIONS_FAILURE:
      return { ...state, loadingPermissions: false, errorPermissions: action.payload.error };

    case CREATE_ROLE_REQUEST:
      return { ...state, loading: true, error: null };
    case CREATE_ROLE_SUCCESS:
      return { ...state, loading: false };
    case CREATE_ROLE_FAILURE:
      return { ...state, loading: false, error: action.payload.error };

    case DELETE_ROLE_REQUEST:
      return { ...state, loading: true, error: null };
    case DELETE_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        permissions: state.permissions.filter((p) => p.role !== action.payload),
      };
    case DELETE_ROLE_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    case GET_USERS_AND_ROLES_START:
      return {
        ...state,
        loadingUsersAndRoles: true,
        errorUsersAndRoles: null,
      };
    case GET_USERS_AND_ROLES_SUCCESS:
      return {
        ...state,
        loadingUsersAndRoles: false,
        usersAndRolesData: action.payload,
      };
    case GET_USERS_AND_ROLES_FAIL:
      return {
        ...state,
        loadingUsersAndRoles: false,
        errorUsersAndRoles: action.payload,
      };
    case UPDATE_USER_ROLES_REQUEST:
      return { ...state, loading: true, error: null };
    case UPDATE_USER_ROLES_SUCCESS:
      return { ...state, loading: false };
    case UPDATE_USER_ROLES_FAILURE:
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
};

export default roleAndPermissionReducer;
